import React from 'react'

const React_Coding_Practice_8 = () => {
  return (
    <div>
      <h1>Coding Pratice 8</h1>
    </div>
  )
}

export default React_Coding_Practice_8
